// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../../../types/schema';

import { gql } from '@apollo/client';
export type WaterfallOverviewBundleSettingsModal_EstateWaterfallFragment = { __typename?: 'EstateWaterfall', id: string, displayName: string, kind?: Types.EstateWaterfallKind | null, firstGrantorDeathYear?: number | null, secondGrantorDeathYear?: number | null, growthProfile?: { __typename?: 'GrowthProfile', id: string, displayName: string } | null, firstGrantorDeath: { __typename?: 'ClientProfile', id: string }, beneficiaryReport: { __typename?: 'EstateWaterfallBeneficiaryReport', _cacheKey: string, beneficiariesBreakdown?: Array<{ __typename?: 'BeneficiaryReportBeneficiaryBreakdown', _cacheKey: string, beneficiary?: { __typename?: 'ClientProfile', id: string, displayName: string } | null, orgBeneficiary?: { __typename?: 'ClientOrganization', id: string, displayName: string } | null }> | null } };

export const Operations = {
  Fragment: {
    WaterfallOverviewBundleSettingsModal_EstateWaterfall: 'WaterfallOverviewBundleSettingsModal_EstateWaterfall' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}

export const WaterfallOverviewBundleSettingsModal_EstateWaterfallFragmentDoc = gql`
    fragment WaterfallOverviewBundleSettingsModal_EstateWaterfall on EstateWaterfall {
  id
  displayName
  kind
  growthProfile {
    id
    displayName
  }
  firstGrantorDeath {
    id
  }
  firstGrantorDeathYear
  secondGrantorDeathYear
  beneficiaryReport {
    _cacheKey
    beneficiariesBreakdown {
      _cacheKey
      beneficiary {
        id
        displayName
      }
      orgBeneficiary {
        id
        displayName: name
      }
    }
  }
}
    `;